module.exports = __webpack_public_path__ + "img/cyanCircle.9bc4b9a5.png";